<template>
  <div class="sales-home-container">
    <!-- 页面主体 (默认显示) -->
    <div class="container">
      <!-- 顶部区域：标题 + 我的球杆按钮 -->
      <div class="header">
        <div class="title">球杆售后服务</div>
        <el-button
            class="my-club-button"
            type="text"
            @click="goToMyClub"
        >
          我的球杆
        </el-button>
      </div>

      <!-- 轮播Banner -->
      <div class="s-banner">
        <el-carousel
            :height="bannerHeight"
            loop
            :arrow="carouselArrow"
            indicator-position="bottom"
            class="carousel-container"
        >
          <el-carousel-item v-for="item in bannerImgList" :key="item.id || item.src">
            <div class="banner-img-wrapper">
              <img
                  :src="item.src"
                  alt="banner图"
                  class="img_item"
                  loading="lazy"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 服务功能列表 -->
      <div class="service-list">
        <div
            v-for="item in salesList"
            :key="item.id || item.src"
            class="service-item"
        >
          <a
              :href="item.url"
              rel="noopener noreferrer"
              class="service-link"
              target=""
          >
            <img
                :src="item.src"
                alt="服务图标"
                class="service-img"
                loading="lazy"
            />
            <span class="service-title">{{ item.title }}</span>
          </a>
        </div>
      </div>

      <!-- 页脚 -->
      <el-footer class="footer">
        <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
      </el-footer>
    </div>

    <!-- 空数据提示 (仅当数据为空时显示) -->
    <div v-if="bannerImgList.length === 0 && salesList.length === 0" class="empty-tip">
      <el-empty description="暂无服务数据"></el-empty>
    </div>
  </div>
</template>

<script>
import { getImgList } from "@/api/home";
import { ImageTypeEnum } from "@/enums/imageTypeEnum";

export default {
  name: "SalesHome",
  data() {
    return {
      // isLoading: true, // <-- 已移除
      bannerHeight: "auto",
      carouselArrow: "never",
      bannerImgList: [],
      salesList: []
    };
  },
  created() {
    this.getBannerAndServiceList();
    window.addEventListener("resize", this.adjustLayout);
  },
  mounted() {
    this.adjustLayout();
    this.$nextTick(() => {
      this.adjustBannerHeightByImg();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustLayout);
  },
  methods: {
    adjustLayout() {
      const winWidth = window.innerWidth;
      this.carouselArrow = winWidth < 768 ? "never" : "hover";
      this.adjustBannerHeightByImg();
    },
    adjustBannerHeightByImg() {
      const winWidth = window.innerWidth;
      const bannerImg = document.querySelector('.banner-img-wrapper .img_item');
      if (bannerImg && bannerImg.naturalWidth > 0) {
        const imgRatio = bannerImg.naturalWidth / bannerImg.naturalHeight;
        let containerWidth;
        if (winWidth < 768) {
          containerWidth = winWidth;
        } else if (winWidth >= 768 && winWidth < 1200) {
          containerWidth = Math.min(winWidth, 900);
        } else {
          containerWidth = Math.min(winWidth, 1200);
        }
        this.bannerHeight = `${containerWidth / imgRatio}px`;
      } else {
        if (winWidth < 768) {
          this.bannerHeight = "65vw";
        } else if (winWidth >= 768 && winWidth < 1200) {
          this.bannerHeight = "40vw";
        } else {
          this.bannerHeight = "400px";
        }
      }
    },
    async getBannerAndServiceList() {
      try {
        const slideId = `${ImageTypeEnum.SALES_HOME_LIST.value},${ImageTypeEnum.SALES_HOME_BANNER.value}`;
        const res = await getImgList(slideId);
        const dataList = res.data || [];
        this.bannerImgList = dataList.filter(item => item.classify === ImageTypeEnum.SALES_HOME_BANNER.value && item.src);
        this.salesList = dataList.filter(item => item.classify === ImageTypeEnum.SALES_HOME_LIST.value && item.src && item.url);

        this.$nextTick(() => {
          this.adjustBannerHeightByImg();
        });
      } catch (error) {
        console.error("售后首页数据加载失败：", error);
        if (this.$message) {
          this.$message.error("数据加载失败，请刷新重试");
        }
      }
    },
    //我的球杆点击事件
    goToMyClub() {
      this.$router.push({
        path: '/my_club',
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.sales-home-container {
  width: 100%;
  min-height: 100vh;
  background: #efefef;


  .empty-tip {
    padding: 50px 0;
    text-align: center;
  }

  .container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    // 顶部区域
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      background: #f6c27a;
    }

    // 顶部标题
    .title {
      text-align: center;
      flex-grow: 1; // 让标题占据剩余空间，实现居中
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      font-weight: bold;
      margin: 0;
    }

    // “我的球杆”按钮样式
    .my-club-button {
      color: #409EFF;
      //font-weight: bold;
      padding: 5px 10px;
      border-radius: 4px;
      //border: 1px solid #161616;
      background: #fff;

      &:hover,
      &:focus {
        color: #fff;
        border-color: #fff;
        background-color: transparent;
      }
    }

    // Banner轮播
    .s-banner {
      width: 100%;
      box-sizing: border-box;

      .carousel-container {
        width: 100%;
      }

      .banner-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f5f5;
      }

      .img_item {
        width: 100%;
        height: auto;
        max-height: 100%;
        object-fit: contain;
      }
    }

    // 服务列表
    .service-list {
      padding: 5px;
      overflow: hidden;
      display: flow-root;
      box-sizing: border-box;

      .service-item {
        float: left;
        width: 50%;
        padding: 5px;
        box-sizing: border-box;

        .service-link {
          display: block;
          padding-top: 1px;
          background: #fff;
          text-align: center;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease;
          text-decoration: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          }

          .service-img {
            height: 80px;
            margin: 2rem auto;
            display: block;
          }

          .service-title {
            display: block;
            width: 100%;
            font-size: 16px;
            text-align: center;
            color: #000;
            font-weight: bold;
            background: #f6c279;
            letter-spacing: 1px;
            padding: 8px 0;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            box-sizing: border-box;
          }
        }
      }
    }

    // 页脚
    .footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      box-sizing: border-box;

      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        margin: 0;
      }
    }
  }

  // ===================== 移动端适配（<768px） =====================
  @media screen and (max-width: 767px) {
    .container {
      .header {
        padding: 0 10px;
      }
      .title {
        font-size: 16px;
        line-height: 60px;
        padding-left: 80px;
      }
      .my-club-button {
        padding: 3px 8px;
        font-size: 16px;
        border-radius: 4px;
      }
      .s-banner {
        margin: 0;
      }
      .service-list {
        .service-item {
          .service-link {
            .service-img {
              height: 80px;
              margin: 1.5rem auto;
            }
            .service-title {
              font-size: 14px;
              padding: 6px 0;
            }
          }
        }
      }
      .footer {
        height: 50px;
        margin-top: 15px;
        p {
          font-size: 9px;
          padding: 0 10px;
          text-align: center;
        }
      }
    }
  }

  // ===================== 平板适配（768px ≤ 宽度 < 1200px） =====================
  @media screen and (min-width: 768px) and (max-width: 1199px) {
    .container {
      max-width: 900px;
      margin: 0 auto;
      padding: 0 20px;
      .header {
        padding: 0 20px;
        margin-top: 10px;
        border-radius: 8px 8px 0 0;
      }
      .title {
        font-size: 18px;
        line-height: 70px;
      }
      .my-club-button {
        padding: 5px 12px;
        font-size: 14px;
      }
      .s-banner {
        margin: 0;
        overflow: hidden;
      }
      .service-list {
        padding: 15px 0;
        .service-item {
          padding: 10px;
          .service-link {
            .service-img {
              height: 150px;
              margin: 2rem auto;
            }
            .service-title {
              font-size: 18px;
              padding: 10px 0;
            }
          }
        }
      }
      .footer {
        height: 55px;
        margin-top: 25px;
        p {
          font-size: 11px;
        }
      }
    }
  }

  // ===================== PC端适配（≥1200px） =====================
  @media screen and (min-width: 1200px) {
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      .header {
        padding: 0 20px;
        margin-top: 20px;
        border-radius: 8px 8px 0 0;
      }
      .title {
        font-size: 22px;
        line-height: 80px;
      }
      .my-club-button {
        padding: 6px 15px;
        font-size: 16px;
      }
      .s-banner {
        margin: 0;
        overflow: hidden;
      }
      .service-list {
        padding: 20px 0;
        .service-item {
          padding: 15px;
          .service-link {
            .service-img {
              height: 200px;
              margin: 2rem auto;
            }
            .service-title {
              font-size: 20px;
              padding: 12px 0;
            }
          }
        }
      }
      .footer {
        height: 60px;
        margin-top: 30px;
        p {
          font-size: 12px;
        }
      }
    }
  }
}
</style>